export enum Ctas {
  MyListingsResult = 'mylistings-result',
  HomePageResults = 'homepage-result',
  SearchResults = 'search-result',
  RvDetails = 'rv-details'
}
